import { RouteInfo } from "@tr/models"

// Menu Items
export const captainProfileLinks: RouteInfo[] = [
]

// Menu Items
export const captainLinks: RouteInfo[] = [
  {
    path: "/captain/dashboard",
    title: "Dashboard",
    icon: "ti-panel",
    permissionsNeeded: ["Manager", "SeniorManager", "SuperUser"]
  },
]
